import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ListItem as MuiListItem } from '@material-ui/core';
export const ListItem = /*#__PURE__*/ React.forwardRef((props, ref)=>/*#__PURE__*/ _jsx(MuiListItem, _object_spread_props(_object_spread({}, props), {
        ref: ref
    })));
